var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLight = function SvgCloseLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close-light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6D4FF",
    d: "M27.646 22.98a.5.5 0 0 0 .708 0L43.98 7.355a.5.5 0 0 1 .707 0l3.958 3.958a.5.5 0 0 1 0 .708L33.02 27.646a.5.5 0 0 0 0 .708L48.646 43.98a.5.5 0 0 1 0 .707l-3.958 3.958a.5.5 0 0 1-.708 0L28.355 33.02a.5.5 0 0 0-.708 0L12.02 48.646a.5.5 0 0 1-.708 0l-3.958-3.958a.5.5 0 0 1 0-.708L22.98 28.355a.5.5 0 0 0 0-.708L7.353 12.02a.5.5 0 0 1 0-.708l3.958-3.958a.5.5 0 0 1 .708 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close-light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgCloseLight;